import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import "../../Style/Theme/index.css";
const KycAnimation = () => {
  const clock = useRef(null);
  const mobile = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: clock.current,
      renderer: "svg",
      animationData: require("../../utils/lottie/loading2.json"),
    });
    lottie.loadAnimation({
      container: mobile.current,
      renderer: "svg",
      animationData: require("../../utils/lottie/loading3.json"),
    });
  }, []);
  return (
    <div
      className="animationFilter"
      style={{
        position: "relative",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        className="mobile"
        ref={mobile}
        style={{
          width: "300px",
          height: "380px",
          position: "relative",
        }}
      >
        <img src="/assets/cloud.svg" className="cloud lottieBg" alt="Cloud" />
        <div ref={clock} className="clock" />
      </div>
    </div>
  );
};

export default KycAnimation;
